import React from 'react';
import type { ThemePalette, TypographyTokens } from '../../theme/tokens';

export interface BtnProps {
  children: React.ReactNode;
  c: ThemePalette;
  typ: TypographyTokens;
  variant?: 'primary' | 'accent' | 'ghost' | 'lucky';
  style?: React.CSSProperties;
  onClick?: () => void;
  icon?: React.ReactNode;
  type?: 'button' | 'submit';
  disabled?: boolean;
}

export const Btn: React.FC<BtnProps> = ({
  children,
  c,
  typ,
  variant = 'primary',
  style = {},
  onClick,
  icon,
  type = 'button',
  disabled,
}) => {
  const styles: Record<string, { bg: string; fg: string; border: string }> = {
    primary: { bg: c.ink, fg: c.bg, border: c.ink },
    accent: { bg: c.accent, fg: c.accentInk, border: c.accent },
    ghost: { bg: 'transparent', fg: c.ink, border: c.line },
    lucky: { bg: c.gradient, fg: '#fff', border: 'transparent' },
  };
  const s = styles[variant];
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className="inline-flex cursor-pointer items-center justify-center gap-2 rounded-[14px] border px-[18px] py-[13px] text-[15px] font-semibold tracking-tight disabled:opacity-50"
      style={{
        background: s.bg,
        color: s.fg,
        border: `1px solid ${s.border}`,
        fontFamily: typ.body,
        ...style,
      }}
    >
      {icon}
      {children}
    </button>
  );
};
